class SearchResultDto {
  public id: number;
  public title: string;
  public principalContent: JSX.Element;
  public url: string;
  public breadcrumb: JSX.Element;
}

export default SearchResultDto;
